var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.276,
    height: 15.48,
    viewBox: "0 0 14.276 15.48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#13130a",
    d: "M424.881 381.912a4.257 4.257 0 1 1-4.257-4.257 4.257 4.257 0 0 1 4.257 4.257m4.214 7.267l-3.809-3.809a5.8 5.8 0 1 0-1.2 1.2l5.013 5.012z",
    transform: "translate(-414.819 -376.107)"
  })));
};
export { SvgSearch as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNC4yNzYiIGhlaWdodD0iMTUuNDgiIHZpZXdCb3g9IjAgMCAxNC4yNzYgMTUuNDgiPgogICAgPHBhdGggZmlsbD0iIzEzMTMwYSIgZD0iTTQyNC44ODEgMzgxLjkxMmE0LjI1NyA0LjI1NyAwIDEgMS00LjI1Ny00LjI1NyA0LjI1NyA0LjI1NyAwIDAgMSA0LjI1NyA0LjI1N200LjIxNCA3LjI2N2wtMy44MDktMy44MDlhNS44IDUuOCAwIDEgMC0xLjIgMS4ybDUuMDEzIDUuMDEyeiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQxNC44MTkgLTM3Ni4xMDcpIi8+Cjwvc3ZnPgo=";